import React, { useEffect, useState } from 'react';
import { faFileExport } from '@fortawesome/free-solid-svg-icons/faFileExport';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { post, excelFileDownload, IPSDTexcelFileDownload } from '../../api';
import FileExportIcon from './FileExportIcon';
import { isSpinnerShowing, spinnerOff, spinnerOn } from '../Spinner';

export default (function IPSDTFileExport({tabView,dtstatus}) {
 

  
  async function excelDownload() {
    //We are using project status for when excel download to provide name and active status we sending in backend to get proper project 

    spinnerOn();
    
    let projectInfo = {
      projectStatus: tabView,
      dtstatus:dtstatus
      
    }
   
    await IPSDTexcelFileDownload(projectInfo);
    spinnerOff();
  }

  return <FileExportIcon  onClick={() => excelDownload()} />;
});
